import { useTheme, createTheme } from "@mui/material/styles";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";
import { options } from "./options";

export function useCustomTheme() {
  const theme = useTheme();
  const customTheme = createTheme(theme, {
    palette: {
      mode: "light",
      background: {
        paper: "#fff",
      },
      text: {
        primary: "#000",
        secondary: "#50d4bf",
      },
    },
    components: {
      MuiStepLabel: {
        styleOverrides: {
          label: {
            color: "#000",
          },
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            '&.MuiButton-contained.Mui-disabled': {
              backgroundColor: "rgba(80, 212, 191,0.8)",
              color: "rgba(255,255,255,0.5)"
            }
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            '&.MuiMenuItem-root:hover': {
              backgroundColor: "rgba(80, 212, 191,0.3)",
            },
            '&.Mui-selected': {
              backgroundColor: "rgba(80, 212, 191,0.8)",
            }
          }
        }
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              color: "rgba(0,0,0,0.4)"
            }   
          }
        }
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            ".Mui-disabled": {
              color: "rgba(0,0,0,0.4) !important"
            }
          }
        }
      },
    }
  });
  return customTheme;
}

export function useTotalTreeWeights(): { totalTrees: number; carbonTonnes: number } {
  const { selection } = useAppSelector((state) => state.wizard);
  const weights:number[] = [];
  for (const key in selection) {
    if (Object.hasOwnProperty.call(selection, key)) {
      if(key === "1" || key === "2") {
        weights.push(selection[key]);
      } else if(key === "7") {
        let weight:number;
        weight = options[key]["list"][selection[key] - 1]?.weight;
        if(selection[key] === 1) {
          const prevSelection = selection[6];
          const prevWeight = options[6]["list"][prevSelection-1]["weight"];
          weight = Math.abs(prevWeight*0.5) * -1; // offset prev value
        }
        weights.push(weight)
      } else {
        const weight = options[key]["list"][selection[key] - 1]?.weight;
        weights.push(weight)
      }
    }
  }
  const carbonTonnes = weights.reduce((total, current) => total + current, 0);

  return {
    totalTrees: Math.ceil(carbonTonnes*6/10),
    carbonTonnes: parseFloat(carbonTonnes.toFixed(2))
  }
}

export function useBackendError(initialError = null) {
  
  const [error, setError] = useState(initialError);
  const { enqueueSnackbar } = useSnackbar();
  
  const clearError = () => setError(null);

  const parseError = (err) => {
    const { response } = err;
    if (!response) {
      // network error
      return {
        message: err.message ? err.message : "Something went wrong! Please try again.",
        status: 0,
      };
    }
    const { response: { data, status } } = err;
    if (!data || !status) {
      // unknown error
      return {
        message: "Unknown error.",
        status: 0,
      };
    }
    if (typeof data === "string") {
      return {
        message: data,
        status,
      };
    } else if (typeof data === "object" && data.error) {
      return {
        message: data.error?.message ? data.error?.message : "Something went wrong! Please try again.",
        status,
      };
    }
  };

  const handleRequestError = (err) => {
    const parsedError = parseError(err);
    enqueueSnackbar(parsedError!.message, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
    });
    console.error(parsedError)
    setError(parsedError as any);
  };

  useEffect(() => {
    return () => {
      clearError();
    };
  }, []);

  return { error, clearError, handleRequestError };
};
